import { computed, ref } from 'vue'
import { PersistentDataService } from '@services/PersistentDataService'
import { defineStore } from 'pinia'
import { MapOptions } from 'src/models/MapOptions'
import type { ViewOptions } from 'src/models/ViewOptions'

const defaultViewOptions: ViewOptions = {
  isLeyendaVisible: true,
  isReducedMode: false
}

export const useFireMapStore = defineStore('fireMap', () => {
  const viewOptions = ref<ViewOptions>(structuredClone(defaultViewOptions))
  const mapOptions = ref<MapOptions>(MapOptions.getDefaultFireMapOptions())
  const opacity = computed(() => mapOptions.value.opacity)
  const blur = computed(() => mapOptions.value.blur)

  const SET_DEFAULT_LAYERS = () => {
    mapOptions.value = {
      ...mapOptions.value,
      ...MapOptions.defaultFireLayers
    }
  }

  const SET_DEFAULT_OPTIONS = () => {
    mapOptions.value = structuredClone({
      ...mapOptions.value,
      ...MapOptions.defaultFireOptions
    })
    viewOptions.value = structuredClone(defaultViewOptions)
  }

  const SET_USER_MAP_OPTIONS = () => {
    mapOptions.value = {
      ...mapOptions.value,
      ...PersistentDataService.getOptions('fireMapOptions')
    }
  }

  const SET_USER_VIEW_OPTIONS = () => {
    viewOptions.value = {
      ...viewOptions.value,
      ...PersistentDataService.getOptions('fireViewOptions')
    }
  }

  return {
    viewOptions,
    mapOptions,
    opacity,
    blur,
    SET_DEFAULT_LAYERS,
    SET_DEFAULT_OPTIONS,
    SET_USER_MAP_OPTIONS,
    SET_USER_VIEW_OPTIONS
  }
})
